<h2 class="av-metric-label m-0">{{ 'app.reports.monitoring.catalog.title' | translate }}</h2>
<div class="av-metric-card__figure">
  <p class="av-metric-value m-0">{{ total() | number: '1.0-0' : language() }}</p>
  <p class="av-metric-hint av-catalog-card__hint m-0">
    {{ 'app.reports.monitoring.catalog.hint' | translate }}
  </p>
</div>
@defer (on immediate) {
  <av-bar-chart
    orientation="horizontal"
    labelKey="app.reports.monitoring.catalog.title"
    [bars]="bars()"
  />
} @placeholder {
  <div class="av-catalog-card__reserve"></div>
} @loading (after 200ms; minimum 400ms) {
  <div class="av-catalog-card__reserve av-chart-placeholder"></div>
} @error {
  <av-empty-state icon="bar_chart" titleKey="shared.api.errors.default" />
}
